<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :isMultiSelect="true"
    ></WsCRUD>
  </WsMain>
</template>
<script>
import model from "@/models/organization_role";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "id",
      "sequence",
      "name", 
      "is_default", 
      "factories", 
      "updated_at"],
    liveSearching: true,
    sortBy: "sequence",
    filterSelects: [
      {
        type: "hasMany",
        label: "",
        textKey: "name",
        modelName: "organization",
        paramName: "organizations",
        placeholder: "篩選適用集團",
      },
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "is_active",
        defaultValue: "1",
        items: [
          {
            value: "1",
            text: "啟用",
          },
          {
            value: "0",
            text: "停用",
          },
        ],
      },
    ],
  }),
};
</script>